module.exports = __webpack_public_path__ + "static/front-010-5a4cba09b70526e5c92a402ba2a6af8e.png";